<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showSnackBar" color="#3ea56e" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-start>
      <v-flex xs12 lg12 xl10 px-0 px-sm-4 pt-4 px-2 pr-lg-12 pr-xl-0>
        <v-layout wrap justify-start pt-4>
          <v-flex
            xs12
            sm3
            md3
            lg3
            xl3
            text-left
            text-uppercase
            style="font-family: poppinsmedium; font-size: 16px; color: #000000"
          >
            <span> Your Orders </span>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs6 sm3 md3 lg2 xl2 px-4>
            <v-btn
              :ripple="false"
              depressed
              outlined
              block
              tile
              color="#0000001f"
              style="background-color: #f9f9f9"
              to="/Orders?type=Active"
            >
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 12px;
                  color: #000000;
                  text-transform: none;
                "
              >
                Active Orders
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 sm3 md3 lg2 xl2 px-4>
            <v-btn
              :ripple="false"
              depressed
              outlined
              block
              tile
              color="#0000001f"
              style="background-color: #f9f9f9"
              to="/Orders?type=Delivered"
            >
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 12px;
                  color: #000000;
                  text-transform: none;
                "
              >
                Delivered Orders
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 sm3 md3 lg2 xl2 px-4>
            <v-btn
              :ripple="false"
              depressed
              outlined
              block
              tile
              color="#0000001f"
              style="background-color: #f9f9f9"
              to="/Orders?type=Cancelled"
            >
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 12px;
                  color: #000000;
                  text-transform: none;
                "
              >
                Cancelled Orders
              </span>
            </v-btn>
          </v-flex>
          <!-- <v-flex xs6 sm3 md3 lg2 xl2>
            <v-form @submit.prevent="appSearch">
              <v-text-field
                class="searchBox"
                v-model="searchKey"
                prepend-inner-icon="mdi-magnify"
                placeholder="Search all Orders"
                single-line
                depressed
                dense
                solo
                flat
                hide-details
                color="#FF0F0F"
              ></v-text-field>
            </v-form>
          </v-flex> -->
        </v-layout>
        <v-layout wrap justify-start pt-4>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start>
          <v-flex xs12 pt-4>
            <v-layout wrap justify-start v-if="products.length > 0">
              <v-flex
                xl12
                pa-2
                v-for="(item, i) in products"
                :key="i"
                text-left
              >
                <v-layout wrap justify-center>
                  <v-flex xs12>
                    <OrdersItem v-bind:storage="item" @stepper="winStepper" />
                  </v-flex>
                  <v-flex xs12 py-4>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-center v-else>
              <v-flex xs12 pa-2 align-self-center>
                <span
                  style="
                    font-family: poppinsregular;
                    font-size: 25px;
                    color: #000000;
                    cursor: pointer;
                  "
                  >Oops! No Products Found</span
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import OrdersItem from "./ordersItem";
export default {
  components: {
    OrdersItem,
  },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      products: [],
      ServerError: false,
      searchKey: null,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/purchase/myorders",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          deliverystatus: this.$route.query.type,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(item) {
      if (item.getData) {
        this.getData();
      }
      this.msg = item.response.msg;
      this.showSnackBar = true;
    },
    appSearch() {},
  },
};
</script>
